export default __webpack_public_path__ + "static/media/jr-sharks-logo-lg.21357dc5.svg";